import axios from 'axios';
import router from "@/router";

class ApiService {
  constructor() {
    // Create an axios instance
    this.api = axios.create({
      //isLocal: window.location.hostname === 'localhost',
      
      //baseURL: window.location.hostname === 'localhost'    ? 'http://localhost:8080/api'  : `${window.location.origin}/api`,

      //baseURL: window.location.hostname === 'localhost'    ? 'http://localhost:8080/api'  : '/api',

      baseURL: process.env.VUE_APP_API_URL,

      //baseURL: 'http://localhost:8080/api', // Replace with your API base URL
      timeout: 10000, // Set a timeout for requests
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Request interceptor
    this.api.interceptors.request.use(
      (config) => {
        // Add authorization token or other custom logic
        const token = localStorage.getItem('authToken');
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        // Handle request errors
        return Promise.reject(error);
      }
    );

    // Response interceptor
    this.api.interceptors.response.use(
      (response) => {
        return response.data;
      },
      (error) => {
        // Handle errors globally
        // console.error('API Error:', error.response || error.message);
        if (error.response && error.response.status === 401) {
          console.warn("Token expired or invalid. Logging out...");
          this.logout();
          router.push("/login"); // Redirect user to login page
        }
        return Promise.reject(error.response?.data || error.message);
      }
    );
  }

  logout() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  }

  // Generic GET method
  async get(endpoint, params = {}) {
    return this.api.get(endpoint, { params });
  }

  // Generic POST method
  async post(endpoint, data = {}) {
    return this.api.post(endpoint, data);
  }

  // Generic PUT method
  async put(endpoint, data = {}) {
    return this.api.put(endpoint, data);
  }

  // Generic DELETE method
  async delete(endpoint) {
    return this.api.delete(endpoint);
  }

  // Add more methods if needed
}

// Export a singleton instance
const apiService = new ApiService();
export default apiService;
